import { onUnmounted } from '@vue/composition-api';
import Vue from 'vue';
import cssLink from '!!file-loader!sass-loader!./css-reset.css';
import remoteCssLink from '!!file-loader!sass-loader!./css-reset-remote.css';
function createCssResetHook(options) {
    const counter = Vue.observable({ value: 0 });
    let linkEl = null;
    return function useCssReset(enabled = true) {
        if (enabled) {
            counter.value++;
            if (counter.value === 1) {
                linkEl?.remove();
                linkEl = document.createElement('link');
                linkEl.rel = 'stylesheet';
                linkEl.href = options.cssHref;
                linkEl.setAttribute(options.dataAttr, '1');
                document.head.appendChild(linkEl);
            }
        }
        onUnmounted(() => {
            if (!enabled)
                return;
            counter.value--;
            if (counter.value === 0) {
                linkEl?.remove();
                linkEl = null;
            }
        });
    };
}
export const useGogoCssReset = createCssResetHook({
    cssHref: cssLink,
    dataAttr: 'data-wuji-gogo-reset',
});
export const useGogoRemoteCssReset = createCssResetHook({
    cssHref: remoteCssLink,
    dataAttr: 'data-wuji-gogo-remote-reset',
});
